module.exports = __webpack_public_path__ + "static/profile_2-5ec0acee42a8d10abf54ae8808758264.jpeg";